import { useTranslation } from 'react-i18next';
import { colors } from '../../../../enums/colors';
import { GRID_UNITS } from '../Model/Model';

/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    Full Stack
 * @Email       kpozos@ibl.mx
 *
 * Logic of the canvas: decides which empty state applies and the grid class of the active layout.
 */
const LayoutBoardApp = ({ layout }) => {
    const { t } = useTranslation();

    const hasLayout = !!layout;
    const hasPanels = (layout?.panels?.length ?? 0) > 0;
    // The rows keep the height of one unit of the canvas, so resizing a panel does not rescale the others //
    const rows = GRID_UNITS;
    const gridClassName = 'event-monitoring-grid custom-scrollbar';

    const layoutChipColors = {
        background: colors.secondary100,
        fontColor: colors.secondary700,
        borderColor: colors.secondary150,
    };

    return {
        t,
        hasLayout,
        hasPanels,
        rows,
        gridClassName,
        layoutChipColors
    };
};

export default LayoutBoardApp;
